module.exports = __webpack_public_path__ + "static/media/bar_chart.58b0ada6.svg";